import { ChangeEvent, useEffect, useRef } from 'react';
import FormField from '../field/FormField';

interface Props {
  value: string;
  name?: string;
  isRequired?: boolean;
  placeholder?: string;
  rows?: number;
  className?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  onChange: (value: string) => void;
  resize?: boolean;
  isFormField?: boolean;
  label?: string;
  modalOpen?: boolean;
  recalculate?: any;
  tabIndex?: number;
  isPrint?: boolean;
  autofocus?: boolean;
}

export const ResizableTextArea = ({
  value,
  name,
  isRequired,
  placeholder,
  rows,
  className,
  onFocus,
  onBlur,
  onChange,
  resize,
  isFormField,
  label,
  modalOpen,
  recalculate,
  tabIndex,
  isPrint,
  autofocus,
}: Props) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  /**
   * Increase height of textarea
   */
  const handleInput = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (ref.current && resize) {
      ref.current.style.height = '';
      ref.current.style.height = `${e.target.scrollHeight}px`;
    }
  };

  useEffect(() => {
    if (ref.current && resize) {
      ref.current.style.height = '';
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }
  }, [value, recalculate]);

  /*   useEffect(() => {
    if (!ref.current || !value || !resize) return;
    ref.current.style.height = 'auto';
    const oneRowHeight = 21;
    // textarea has 100px width
    const oneRowWidth = 120;
    const textReqWidth = getTextReqWidth(value) ?? 100;
    const valueRowHeight =
      textReqWidth > oneRowWidth
        ? Math.ceil(textReqWidth / oneRowWidth) * oneRowHeight
        : oneRowHeight;
    ref.current.style.height = `${valueRowHeight}px`;
  }, [value]);

  // Returns text required width in pixels
  const getTextReqWidth = (text: string) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) context.font = getComputedStyle(document.body).font;
    return context?.measureText(text).width;
  }; */

  /**
   * Dont allow arrow up and down in input when modal is open
   */
  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (modalOpen && (event.key === 'ArrowUp' || event.key === 'ArrowDown'))
        event.preventDefault();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalOpen]);

  if (isFormField && name)
    return (
      <div className="relative">
        <FormField
          id={name}
          name={name}
          label={label}
          onFocus={() => onFocus && onFocus()}
          onBlur={onBlur}
          onChange={(e) => onChange(e.target.value)}
          value={value}
          className={className}
        />
      </div>
    );
  return (
    <>
      <section>
        <textarea
          tabIndex={tabIndex}
          autoFocus={autofocus}
          ref={ref}
          name={name}
          className={`h-auto text-xs min-w-max resize-none border border-1 rounded-md ${className}`}
          rows={rows ?? 1}
          value={value}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          placeholder={placeholder}
          required={isRequired}
          // resize for print
          style={{
            width: isPrint && value.length > 10 ? `${value.length}ch` : undefined,
            maxWidth: '300px',
          }}
          onInput={handleInput}
        />
      </section>
    </>
  );
};
